const { registerStore, combineReducers, subscribe } = wp.data;

function loadState( key, initial ) {
	try {
		const saved = localStorage.getItem( key );
		if ( saved !== null ) {
			return JSON.parse( saved );
		}
	} catch {
	}
	return initial;
}

function saveState( key, value ) {
	try {
		localStorage.setItem(
			key,
			JSON.stringify( value )
		);
	} catch {
	}
}

const actions = {
	setStatisticUserFilter( filter ) {
		return {
			type: 'SET_STATISTIC_USER_FILTER',
			filter,
		};
	},
	selectUseCase( useCase ) {
		return {
			type: 'use-case/select',
			useCase,
		};
	},
};

// Reducer for step toggling.
function userStatistic( state = {
	userFilter: "all",
}, action ) {
	switch ( action.type ) {
	case 'SET_STATISTIC_USER_FILTER':
		return {
			...state,
			userFilter: action.filter,
		};
	}
	return state;
};

// Reducer for user navigation settings.
function userNavigation( state = loadState( 'userNavigation', {
	selectedUseCase: "",
} ), action ) {
	switch ( action.type ) {
	case 'use-case/select':
		return {
			...state,
			selectedUseCase: action.useCase,
		};
	}
	return state;
};


const Store = registerStore( 'iportal-core', {
	reducer: combineReducers( {
		userNavigation,
		userStatistic,
	} ),
	actions,
	selectors: {
		getSelectedUseCase( state ) {
			return state.userNavigation.selectedUseCase;
		},
		getStatisticUserFilter( state ) {
			return state.userStatistic.userFilter;
		},
	},
} );

subscribe( () => {
	saveState(
		'userNavigation',
		{
			selectedUseCase: Store.getState().userNavigation.selectedUseCase,
		}
	);
} );

export { Store as default };
